import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ApiAgentService} from '../../../services/api-agent.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NewSubAccountCountResponse} from '../../../models/new-sub-account-count-response';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-new-sub-account',
  templateUrl: './new-sub-account.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./new-sub-account.component.scss']
})
export class NewSubAccountComponent implements OnInit {

  loading: boolean;
  showOtp: boolean;
  approvalRequestNo: number;
  form: FormGroup;
  otpForm: FormGroup;
  @ViewChild('modalElm') modalElm: ElementRef;
  submitted: boolean;
  @Output('onResponseReceived') onResponseReceived = new EventEmitter<NewSubAccountCountResponse>();

  @ViewChild('infoModal') infoModal: ElementRef;
  modalTitle: string;
  modalMsg: string;


  constructor(private api: ApiAgentService, private loader: GlobalLoaderService, private formBuilder: FormBuilder, private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      subAccountCount: ['', [Validators.required, Validators.pattern(/\-?\d*\.?\d{1,2}/)]],
      justification: ['', [Validators.required, Validators.max(4000)]],
    });

    this.otpForm = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern(/\-?\d*\.?\d{1,2}/)]],
    });

    this.showOtp = false;
  }

  private showToast(title, msg) {
    // Snackbar.show({
    //   text: msg,
    //   pos: 'bottom-center'
    // });
    this.modalTitle = title;
    this.modalMsg = msg;
    $(this.infoModal.nativeElement).modal('show');
  }

  get f() {
    return this.form.controls;
  }

  get of() {
    return this.otpForm.controls;
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
  }

  async addSubAccounts() {
    this.submitted = true;
    if (this.form.valid) {
      this.loading = true;
      let subAccountCount = this.form.value['subAccountCount'];
      let justification = this.form.value['justification'];
      try {

        let response: NewSubAccountCountResponse = await this.api.requestSubAccountsCount(subAccountCount, justification);
        this.loading = false;

        if (response.approvalRequestNo || response.approved) {
          this.showOtp = true;
          this.approvalRequestNo = response.approvalRequestNo;
        } else {
          let msg = await this.translate.get(response.response).toPromise();
          this.showToast(' ', msg);
        }
      } catch (e) {
        this.loading = false;
        this.showToast(' ', 'Internal Server Error');
      }
    }
  }

  async confirmOtp() {
    this.submitted = true;
    if (this.otpForm.valid) {
      this.loading = true;
      let subAccountCount = this.form.value['subAccountCount'];
      let otp = this.otpForm.value['otp'];
      try {
        let response: NewSubAccountCountResponse = await this.api.requestSubAccountsCountAbsher(otp, this.approvalRequestNo);
        this.loading = false;
        if (response.approvalRequestNo && response.absherConfirmed) {
          response.subAccountCount = subAccountCount;
          this.onResponseReceived.emit(response);
        } else {
          let msg = await this.translate.get(response.response).toPromise();
          this.showToast(' ', msg);
        }
      } catch (e) {
        console.log(e);
        this.loading = false;
        this.showToast(' ', 'Internal Server Error');
      }
    }
  }

  openModal() {
    setTimeout(async () => {
      this.loadResources().then(() => {
        $(this.modalElm.nativeElement).modal('show');
      });
    }, 500);
  }

  closeModal() {
    $(this.modalElm.nativeElement).modal('hide');
  }
}
